import { render, staticRenderFns } from "./plan copy.vue?vue&type=template&id=ddf8b6ca"
import script from "./plan copy.vue?vue&type=script&lang=js"
export * from "./plan copy.vue?vue&type=script&lang=js"
import style0 from "./plan copy.vue?vue&type=style&index=0&id=ddf8b6ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports